import { render, staticRenderFns } from "./training.feedback.vue?vue&type=template&id=a1321f84&scoped=true&"
import script from "./training.feedback.vue?vue&type=script&lang=js&"
export * from "./training.feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1321f84",
  null
  
)

export default component.exports